import React from 'react'
import styles from './Media.module.css';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import YouTubeIcon from '@material-ui/icons/YouTube';

const Media = () => {
    return (
        <div className={styles.media}>
            <div className={styles.media_icons}>
                <div>
                    <div className={styles.icon}>
                        <TwitterIcon className={ styles.fa}/>
                       
                       
                    </div>
                </div>
                <div>
                    <div className={styles.icon}>
                        <LinkedInIcon className={styles.fa}/>
                        {/* <i class="fa fa-linkedin"></i> */}
                    </div>
                </div>
                <div>
                    <div className={styles.icon}>
                        <InstagramIcon className={styles.fa}/>
                        {/* <i class="fa fa-instagram"></i> */}
                    </div>
                </div>
                <div>
                    <div className={styles.icon}>
                        <FacebookIcon className={styles.fa}/>
                        {/* <i class="fa fa-facebook"></i> */}
                    </div>
                </div>
                <div>
                    <div className={styles.icon}>
                        <YouTubeIcon className={styles.fa}/>
                        {/* <i class="fa fa-youtube"></i> */}
                    </div>
                </div>
            </div>
            <div className={styles.menu}>
                <div className={styles.left_col}>
                    <h5>About</h5>
                    <h5>Ambassador</h5>
                    <h5>Site Status</h5>
                    <h5>Careers </h5>
                    <h5>Support</h5>
                </div>
                <div className={styles.right_col}>
                    <h5>Official Blog</h5>
                    <h5>Must Read </h5>
                    <h5>Hashnode APIs</h5>
                    <h5>Media</h5>
                </div>
            </div>
            <div className={styles.bottom_row}>
                {/* <div className={styles.top_row}>
                    <h5>Privacy</h5>
                    <h5>Terms</h5>
                </div> */}
                <div style={{margin:"0", padding:"0",  height:"10px"}} className={styles.btn_row}>
                    <h5>© 2021 · Hashnode</h5>
                </div>
            </div>
        </div>
    )
}

export default Media
